export const borrowerLensAbi = [
  {
    "inputs": [
      {
        "internalType": "contract Borrower",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "getHealth",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "healthA",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "healthB",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Borrower",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "getSummary",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "balanceEth",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "balance0",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "balance1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "liabilities0",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "liabilities1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "slot0",
        "type": "uint256"
      },
      {
        "internalType": "uint128[]",
        "name": "liquidity",
        "type": "uint128[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Borrower",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "getUniswapPositions",
    "outputs": [
      {
        "internalType": "int24[]",
        "name": "positions",
        "type": "int24[]"
      },
      {
        "internalType": "uint128[]",
        "name": "liquidity",
        "type": "uint128[]"
      },
      {
        "internalType": "uint256[]",
        "name": "fees",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Borrower",
        "name": "borrower",
        "type": "address"
      }
    ],
    "name": "isInUse",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      },
      {
        "internalType": "contract IUniswapV3Pool",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract IUniswapV3Pool",
        "name": "pool",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "bytes12",
        "name": "salt",
        "type": "bytes12"
      },
      {
        "internalType": "address",
        "name": "caller",
        "type": "address"
      },
      {
        "internalType": "contract Factory",
        "name": "factory",
        "type": "address"
      }
    ],
    "name": "predictBorrowerAddress",
    "outputs": [
      {
        "internalType": "address",
        "name": "borrower",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;
